import { render, staticRenderFns } from "./ModalLicenseSubscribeFail.vue?vue&type=template&id=3520cc0b&scoped=true&"
import script from "./ModalLicenseSubscribeFail.vue?vue&type=script&lang=js&"
export * from "./ModalLicenseSubscribeFail.vue?vue&type=script&lang=js&"
import style0 from "./ModalLicenseSubscribeFail.vue?vue&type=style&index=0&id=3520cc0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3520cc0b",
  null
  
)

export default component.exports